import { get, isString } from 'lodash';

let defaultState = {
    data: {},
    status: false,
    fetching: false,
    serverError: []
}

export default function contentReducer(state = {
    config: defaultState,
    page: defaultState,
    article: defaultState,
    search: defaultState
}, action) {
    switch (action.type) {
        case "FETCH_CONTENT_PENDING": {
            const { meta: { attribute } } = action;
            return {
                ...state,
                [attribute]: {
                    ...defaultState,
                    fetching: true
                }
            }
        }
        case "FETCH_CONTENT_REJECTED": {
            const { meta: { attribute } } = action;
            return {
                ...state,
                [attribute]: {
                    ...defaultState,
                    serverError: get(action.payload, 'response.data'),
                    status: get(action.payload, 'response.status'),
                }
            }
        }
        case "FETCH_CONTENT_FULFILLED": {
            const { meta: { attribute } } = action;
            const { data, status } = action.payload;
            return {
                ...state,
                [attribute]: {
                    ...defaultState,
                    data,
                    status
                }
            }
        }
        case "CONTENT_APPEND_PENDING": {
            const { attribute } = action.meta;
            return {
                ...state,
                [attribute]: {
                    ...state[attribute],
                    action: action.meta.action,
                    fetching: true,
                    status: false,
                }
            }
        }
        case "CONTENT_APPEND_FULFILLED": {
            const { attribute } = action.meta;
            let list = get(action.payload, "data.data.list") || [];
            const limit = get(action.meta, 'data.limit', 20);
            const total = get(action.meta, 'data.total', 0) || get(action.payload, "data.data.total", 0);
            if (isString(list)) {
                list = JSON.parse(list || '[]');
            }

            const finalList = [
                ...get(state[attribute], 'data.data.list', []),
                ...list
            ]

            return {
                ...state,
                [attribute]: {
                    ...state[attribute],
                    fetching: false,
                    data: {
                        data: {
                            list: finalList
                        }
                    },
                    total,
                    end: (finalList.length === total || list.length < limit) ? true : false,
                    status: get(action.payload, "status", 400),
                }
            }
        }
        case "CONTENT_APPEND_REJECTED": {
            const { attribute } = action.meta;
            return {
                ...state,
                [attribute]: {
                    ...state[attribute],
                    fetching: false,
                    end: true,
                    serverError: get(action.payload, 'response.data'),
                    status: get(action.payload, "status", 400),
                }
            }
        }
        default:
            return state;
    }
}